export interface ReportPeriod {
  year: string;
  month: string;
}

export const MONTH_OPTIONS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

/** Scoreboard reports default to the most recently completed month. */
export const getDefaultPeriod = (): ReportPeriod => {
  const now = new Date();
  const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return {
    year: String(previousMonth.getFullYear()),
    month: String(previousMonth.getMonth() + 1),
  };
};

/** The reporting window: the current year back 6 more years, newest first. */
export const getYearOptions = (): string[] => {
  const currentYear = new Date().getFullYear();
  const years: string[] = [];
  for (let value = currentYear; value >= currentYear - 6; value--) {
    years.push(String(value));
  }
  return years;
};

/** e.g. "1,204 rows for June 2026" — `noun` is the singular form. */
export const formatRunSummary = (
  count: number,
  noun: string,
  monthLabel: string,
): string =>
  `${count.toLocaleString()} ${noun}${count === 1 ? "" : "s"} for ${monthLabel}`;
